import * as React from 'react';
import { Icon } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

interface IReportFiltersPanel {
  // Las columnas de filtros (divs con className="report-filters-col"), igual que antes.
  children: React.ReactNode;
  // Los botones de accion (Buscar, Limpiar, etc.), se muestran siempre, incluso colapsado en movil.
  actions: React.ReactNode;
  // Clases adicionales para el contenedor raiz (por ejemplo "mb-2" para el espaciado que
  // tenia la fila de filtros antes de este componente).
  className?: string;
}

// Envoltorio reutilizable para las filas de filtros de Reporting (ReportingFilters,
// ReportingFiltersPeriodo, ReportingBillableDistribution, y cualquier otra pantalla que arme
// su propia fila de "report-filters-col").
//
// En escritorio/tablet se comporta igual que antes: todos los filtros visibles en una fila que
// se acomoda sola (report-filters-row / report-filters-col / report-filters-actions).
//
// En movil (<=639px) agrega un encabezado "Filtros" con una flecha para expandir/contraer:
// colapsado, solo se ve el encabezado y el boton de accion (Buscar); al desplegar, aparecen
// los filtros apilados verticalmente, con un texto pequeño debajo del boton para volver a
// contraerlos.
export const ReportFiltersPanel: React.FC<IReportFiltersPanel> = ({ children, actions, className }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = React.useState(false);

  const toggleExpanded = () => setIsExpanded((prev) => !prev);

  return (
    <div className={`report-filters-panel${className ? ` ${className}` : ''}`}>
      <div className="report-filters-mobile-header" onClick={toggleExpanded}>
        <span className="report-filters-mobile-header-title">{t('Filtros')}</span>
        <Icon iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'} />
      </div>
      <div className={`report-filters-row${isExpanded ? '' : ' report-filters-row-collapsed'}`}>
        {children}
        <div className="report-filters-actions">{actions}</div>
      </div>
      <button type="button" className="report-filters-toggle-text" onClick={toggleExpanded}>
        {isExpanded ? t('Contraer filtros') : t('Desplegar filtros')}
      </button>
    </div>
  );
};

export default ReportFiltersPanel;
